import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';
import {twMerge} from 'tailwind-merge';

import {InstrumentedWBLogoLoader} from '../../components/utility/InstrumentedLoader';
import {appLoaderOverlayClassName} from '../../containers/appLoaderOverlay';
import {isSpecificPath} from '../../routes';
import {GROUP_WORKSPACE_PATHS} from '../../routes/workspace/groupWorkspacePaths';
import {PROJECT_WORKSPACE_PATHS} from '../../routes/workspace/multiRunWorkspacePaths';
import {RUN_WORKSPACE_PATHS} from '../../routes/workspace/singleRunWorkspacePaths';
import {SWEEP_WORKSPACE_PATHS} from '../../routes/workspace/sweepWorkspacePaths';

const WORKSPACE_LOADING_TEXTS = [
  'Loading project...',
  'Gathering workspace settings...',
  'Loading runs...',
  'Generating visualizations...',
];

// Above every page element so the branded splash reads as the whole screen.
const WORKSPACE_LOADER_STANDALONE_Z = 'z-[999]';

export const WorkspaceLoader = () => {
  return (
    <TailwindContents>
      <div
        className={twMerge(
          appLoaderOverlayClassName(WORKSPACE_LOADER_STANDALONE_Z),
          'flex items-center justify-center bg-wb-page'
        )}>
        <InstrumentedWBLogoLoader
          name="workspace-loader"
          loadingTexts={WORKSPACE_LOADING_TEXTS}
        />
      </div>
    </TailwindContents>
  );
};

/**
 * Returns true if path should use WorkspaceLoader as initial loading screen.
 * Includes multi & single run workspaces, and full-screened panels on any workspace.
 * Does not include runs table page.
 */
export function isWorkspaceLoaderPath(path: string): boolean {
  return isSpecificPath(path, [
    ...PROJECT_WORKSPACE_PATHS,
    ...RUN_WORKSPACE_PATHS,
    ...GROUP_WORKSPACE_PATHS,
    ...SWEEP_WORKSPACE_PATHS,
  ]);
}
